<template>
  <van-dialog
    :value="true"
    class="pwc-dialog-cropper"
    :style="{ width: `${width}px`, height: `${height}px` }"
    :show-confirm-button="false"
  >
    <div class="pwc-cropper-container">
      <img ref="source-img" :src="src" style="display: none">
      <van-button
        size="small"
        class="cropper-action"
        type="primary"
        @click="crop"
      >确定</van-button>
    </div>
  </van-dialog>
</template>

<script>
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import { help } from './help'
import Detect from '@/util/detect'
const isMobile = Detect(window.navigator.userAgent).mobile()

export default {
  mixins: [help],
  props: {
    src: {
      type: String,
      default: ''
    },
    ratio: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      width: isMobile ? window.innerWidth : this.getMaxSupportWidth(),
      height: window.innerHeight,
      cropper: null
    }
  },
  mounted() {
    this.initCropper()
  },
  methods: {
    initCropper() {
      const aspectRatio = this.ratio
      this.cropper = new Cropper(this.$refs['source-img'], {
        aspectRatio,
        dragMode: 'move',
        viewMode: 1,
        minCropBoxWidth: 100,
        zoomable: false,
        movable: false
      })
    },
    crop() {
      if (this.cropper) {
        const data = this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
        this.$emit('crop', data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-dialog-cropper {
  border-radius: 0 !important;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  .pwc-cropper-container {
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.8);
    img {
      display: block;
      max-width: 100%;
    }
    .cropper-action {
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 9999;
    }
  }
}
</style>

<style lang="scss">
.pwc-dialog-cropper {
  .van-dialog__content {
    height: 100%;
  }
  .cropper-bg,
  .cropper-modal {
    background: none !important;
  }
}
</style>
